import React from 'react';
import styles from './cutleryDelivery.module.scss';
import CountEditor from '../../countEditor/countEditor';
import SmallBtn from '../../buttons/smallBtn/smallBtn';
import { displayPrice } from 'src/logic/utils/price';


type ItemProps = {
  count: number;
  updateCount: (quantity: number) => void;
  price: number;
  label: string;
}

const AdditionItem = ({ label, count, price, updateCount }: ItemProps) => (
  <div>
    <div className={styles.item}>
      <p>{label}</p>
      <CountEditor
        value={count}
        updateCount={updateCount}
        small
        limit={100}
      />
      {count > 0 && (
        <SmallBtn action={() => updateCount(-count)}>usuń</SmallBtn>
      )}
    </div>
    <b className={styles.value}>{displayPrice(price * count)}</b>
  </div>
);

type Props = {
  cutlery: ItemProps;
  thermalBag?: ItemProps;
}

const DeliveryAdditions	= ({ cutlery, thermalBag }: Props) => (
  <div className={styles.container}>
  <h3 className={styles.title}>Dodatki</h3>
    <AdditionItem {...cutlery}  />
    {thermalBag && <AdditionItem {...thermalBag}  />}
</div>
);

export default DeliveryAdditions;
